[
  "ah",
  "apple",
  "atsc",
  "epub",
  "hp",
  "khtml",
  "moz",
  "ms",
  "o",
  "rim",
  "ro",
  "tc",
  "wap",
  "webkit",
  "xv"
]



//////////////////
// WEBPACK FOOTER
// ./~/vendors/index.json
// module id = 4031
// module chunks = 0